import { render } from "./SelecionarCaixa.vue?vue&type=template&id=671045de&scoped=true&ts=true"
import script from "./SelecionarCaixa.vue?vue&type=script&lang=ts"
export * from "./SelecionarCaixa.vue?vue&type=script&lang=ts"

import "./SelecionarCaixa.vue?vue&type=style&index=0&id=671045de&scoped=true&lang=css"

import exportComponent from "D:\\Desenvolvimento\\NeoXFront\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-671045de"]])

export default __exports__